export const getExpirationDateFixed = (expiration) => {
    const datetime = new Date();

    datetime.setMonth(datetime.getMonth() + expiration);
    datetime.setHours(0, 0, 0, 0); // Horario fixo até meia noite.

    const year = datetime.getFullYear();
    const month = String(datetime.getMonth() + 1).padStart(2, '0'); // Meses são baseados em zero
    const day = String(datetime.getDate()).padStart(2, '0');
    const hours = String(datetime.getHours()).padStart(2, '0');
    const minutes = String(datetime.getMinutes()).padStart(2, '0');
    const seconds = String(datetime.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const getExpirationDate = (expiration) => {
    const now = new Date();
    const datetime = new Date();

    datetime.setMonth(datetime.getMonth() + expiration);

    const timeDifference = datetime.getTime() - now.getTime();

    // Diminuir a diferença do horário
    datetime.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
    datetime.setTime(datetime.getTime() - timeDifference);

    return datetime.toISOString().slice(0, 19).replace('T', ' ');
};

export const timerValue = [5, 8, 10];